"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BridgeProvider = exports.BridgeType = void 0;
var BridgeType;
(function (BridgeType) {
    BridgeType["AXELAR_GMP"] = "gmp";
    BridgeType["AXELAR_ITS"] = "its";
    BridgeType["CCTP"] = "cctp";
    BridgeType["NOBLE_CCTP"] = "noble-cctp";
    BridgeType["IBC"] = "ibc";
})(BridgeType || (exports.BridgeType = BridgeType = {}));
var BridgeProvider;
(function (BridgeProvider) {
    BridgeProvider["AXELAR"] = "axelar";
    BridgeProvider["CCTP"] = "cctp";
    BridgeProvider["NOBLE_CCTP"] = "noble-cctp";
    BridgeProvider["IBC"] = "ibc";
    BridgeProvider["PFM"] = "pfm";
})(BridgeProvider || (exports.BridgeProvider = BridgeProvider = {}));
//# sourceMappingURL=index.js.map